export const initMicroApps = () => {
  const apps = [
    () => import('@ce-bo/customer-app/setup'),
    () => import('@ce-bo/online-store-app/setup'),
    // () => import('@ce-bo/ingredient-app/setup'),
    // () => import('@ce-bo/payment-app/setup'),
    () => import('@ce-bo/purchase-order-app/setup'),
  ];

  Promise.all(apps.map((app) => app().catch((error) => console.error(error))));
};
